module.exports = __webpack_public_path__ + "static/Anna Marie-c9923953bf26025106ad15f9dd22aa0a.jpeg";